import { useState } from 'react';
import { PERSONA_QUESTIONNAIRE } from '../../content/personaContent';
import styles from './Initializer.module.css';

const MAX_LENGTH = 250;

const groupQuestionsBySection = (questions) => {
  return questions.reduce((acc, q) => {
    (acc[q.section] = acc[q.section] || []).push(q);
    return acc;
  }, {});
};

// A series of questions to gain a decent background on the persona (a minor version of 'memories')
function SubstanceFormStep({
  personaData,
  setPersonaData,
  onNext,
  onBack,
  currentStepNumber,
  totalSteps,
}) {
  const [formData, setFormData] = useState(personaData.narrativeData || {});
  const [errors, setErrors] = useState({});

  const groupedQuestions = groupQuestionsBySection(PERSONA_QUESTIONNAIRE);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.length > MAX_LENGTH) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    PERSONA_QUESTIONNAIRE.forEach((item) => {
      const fieldName = item.field_name;
      if (formData[fieldName] && formData[fieldName].length > MAX_LENGTH) {
        newErrors[fieldName] =
          `Response cannot exceed ${MAX_LENGTH} characters.`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      setPersonaData((prevData) => ({ ...prevData, narrativeData: formData }));
      onNext();
    }
  };

  return (
    <div>
      <h3>
        Step {currentStepNumber}/{totalSteps}: Add Substance & Backstory
        (Optional)
      </h3>
      <p>
        Answer these questions to give your persona depth, motivation, and a
        unique worldview. You can skip any you're unsure about for now.
      </p>

      {Object.entries(groupedQuestions).map(([sectionName, questions]) => (
        <fieldset key={sectionName} className={styles.formSection}>
          <legend>{sectionName}</legend>
          {questions.map(({ field_name, question }) => (
            <div key={field_name} className={styles.formGroup}>
              <div className={styles.labelRow}>
                <label htmlFor={field_name}>{question}</label>
                <span className={styles.charCounter}>
                  {formData[field_name]?.length || 0} / {MAX_LENGTH}
                </span>
              </div>
              <textarea
                className={errors[field_name] ? styles.errorInput : ''}
                id={field_name}
                name={field_name}
                value={formData[field_name] || ''}
                onChange={handleChange}
                rows="3"
              />
              {errors[field_name] && (
                <p className="errorText">{errors[field_name]}</p>
              )}
            </div>
          ))}
        </fieldset>
      ))}

      <div className={styles.buttonGroup}>
        <button onClick={onBack} className="action-button secondary">
          Back
        </button>
        <button onClick={handleNext} className="action-button primary">
          Next
        </button>
      </div>
    </div>
  );
}

export default SubstanceFormStep;
